module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar field       = model.fields[formMapping.modelFieldIndex];\nvar fieldConfig = field.config || {};\nvar direction   = 'none';\nvar directionClass = '';\nvar o;\nvar orderPriority = '';\nfor(o in model.resourceFilters.order){\nif(model.resourceFilters.order[o].fieldCode == field.fieldCode){\ndirection       = model.resourceFilters.order[o].direction;\ndirectionClass  = '-' + direction;\nif(model.resourceFilters.order.length > 1){\norderPriority = parseInt(o) + 1;\n}\nbreak;\n}\n}\nvar widthAttribute = '';\nif(fieldConfig.width){\nwidthAttribute = ' width=\"' + field.config.width + '\"'\n}\nvar colSpan = 1;\nvar rowSpan = 1;\nif(fieldConfig.colSpan) colSpan = fieldConfig.colSpan;\nif(fieldConfig.rowSpan) rowSpan = fieldConfig.rowSpan;\nvar additionalClasses = [];\nif(field.fieldCode) additionalClasses.push('headOf_' + field.fieldCode);\nif(fieldConfig.textAlign === 'right')       additionalClasses.push('textAlignRight')\nelse if(fieldConfig.textAlign === 'center') additionalClasses.push('textAlignCenter')\nvar isFieldSortable = (config.isSortable && !(config.preventSortOfField || {})[field.fieldCode || 'nonExistingFieldCode']);\n%>\n<td class=\"<%= additionalClasses.join(' ') %>\" colspan=\"<%= colSpan %>\" rowspan=\"<%= rowSpan %>\" data-field-code=\"<%- field.fieldCode %>\" data-order-direction=\"<%- direction %>\"<%- widthAttribute %>>\n<%= ((field || {}).lang[(((storage || {}).user || {}).data || {}).langCode || 'de-at'] || {}).label || '' %>\n<%\nif(isFieldSortable){\n%>\n<i class=\"fi fi-sort<%- directionClass %>\"></i>\n<span class=\"orderPriority\"><%= orderPriority %></span>\n<%\n}\n%>\n</td>"
  , __filename = "node_modules/frontend-controller/baseComponents/tableSimple/headCol.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var field       = model.fields[formMapping.modelFieldIndex];
var fieldConfig = field.config || {};
var direction   = 'none';
var directionClass = '';
var o;
var orderPriority = '';
for(o in model.resourceFilters.order){
if(model.resourceFilters.order[o].fieldCode == field.fieldCode){
direction       = model.resourceFilters.order[o].direction;
directionClass  = '-' + direction;
if(model.resourceFilters.order.length > 1){
orderPriority = parseInt(o) + 1;
}
break;
}
}
var widthAttribute = '';
if(fieldConfig.width){
widthAttribute = ' width="' + field.config.width + '"'
}
var colSpan = 1;
var rowSpan = 1;
if(fieldConfig.colSpan) colSpan = fieldConfig.colSpan;
if(fieldConfig.rowSpan) rowSpan = fieldConfig.rowSpan;
var additionalClasses = [];
if(field.fieldCode) additionalClasses.push('headOf_' + field.fieldCode);
if(fieldConfig.textAlign === 'right')       additionalClasses.push('textAlignRight')
else if(fieldConfig.textAlign === 'center') additionalClasses.push('textAlignCenter')
var isFieldSortable = (config.isSortable && !(config.preventSortOfField || {})[field.fieldCode || 'nonExistingFieldCode']);

    ; __line = 31
    ; __append("\n<td class=\"")
    ; __line = 32
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\" colspan=\"")
    ; __append(escapeFn( colSpan ))
    ; __append("\" rowspan=\"")
    ; __append(escapeFn( rowSpan ))
    ; __append("\" data-field-code=\"")
    ; __append( field.fieldCode )
    ; __append("\" data-order-direction=\"")
    ; __append( direction )
    ; __append("\"")
    ; __append( widthAttribute )
    ; __append(">\n")
    ; __line = 33
    ; __append(escapeFn( ((field || {}).lang[(((storage || {}).user || {}).data || {}).langCode || 'de-at'] || {}).label || '' ))
    ; __append("\n")
    ; __line = 34
    ; 
if(isFieldSortable){

    ; __line = 36
    ; __append("\n<i class=\"fi fi-sort")
    ; __line = 37
    ; __append( directionClass )
    ; __append("\"></i>\n<span class=\"orderPriority\">")
    ; __line = 38
    ; __append(escapeFn( orderPriority ))
    ; __append("</span>\n")
    ; __line = 39
    ; 
}

    ; __line = 41
    ; __append("\n</td>")
    ; __line = 42
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/tableSimple/headCol.ejs

}